const validate = (values) => {
  const errors = {};
  if (!values.login) {
    errors.login = 'Informe seu usuário para acessar o Portal!';
  }

  if (!values.password) {
    errors.password = 'Informe sua senha para acessar o Portal!';
  }
  return errors;
};

export default validate;
